
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  signal
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TwcGroupLayer } from '../../../../../../layer-type-services/group/twc-group.layer';
import { FlightLevelSelectComponent } from '../../../../../../twc-legend/components/flight-level-select/flight-level-select.component';
import { TimeSpanSelectComponent } from '../../../../../../twc-legend/components/time-span-select/time-span-select.component';
import { TwcLegendComponent } from '../../../../../../twc-legend/twc-legend.component';
import { TempsWindsAloftSvgComponent } from './temps_winds_aloft_svg/temps-winds-aloft-legend-svg';
import {
  TwcVectorTileLayer,
  VectorStyleLayer
} from '../../../../../../layer-type-services/vector-tile/twc-vector-tile.layer';

/**
 * READ THE ANNOTATIONS
 * Winds Aloft Legend Component works different as the layers are a group layer.
 * SEE ALSO - temps-winds-aloft.plugin.service.ts
 */
@Component({
  selector: 'jmkw-ui-temps-winds-aloft-legend',
  templateUrl: './temps-winds-aloft-legend.component.html',
  styleUrls: ['./temps-winds-aloft-legend.component.scss'],
  standalone: true,
  imports: [
    TempsWindsAloftSvgComponent,
    TimeSpanSelectComponent,
    FlightLevelSelectComponent,
    FormsModule
],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TempsWindsAloftLegendComponent
  extends TwcLegendComponent
  implements OnInit
{
  override layer?: TwcGroupLayer;
  flightLevelValues = signal<string[]>([]);
  windsAloftLayer!: TwcVectorTileLayer;
  tempsAloftLayer!: TwcVectorTileLayer;

  get windsAloftIconOverlap(): boolean {
    return this.windsAloftLayer?.currentStyleInfo?.style.layers[0].layout[
      'icon-allow-overlap'
    ];
  }

  set windsAloftIconOverlap(allowOverlap: boolean) {
    this.windsAloftLayer?.currentStyleInfo?.style.layers.forEach(
      (layer: VectorStyleLayer) => {
        if (layer.layout) {
          this.windsAloftLayer.setLayoutProperties(layer.id, {
            ...layer.layout,
            'icon-allow-overlap': allowOverlap
          });
        }
      }
    );
  }

  override ngOnInit(): void {
    // Call the parent's ngOnInit to set up plugin, handle metadata updates, etc.
    super.ngOnInit();

    const layer = this.toolkitApiService.getLayerById<TwcGroupLayer>(this.id!);

    // Get the layer if not already set by the parent
    if (!this.layer && layer) {
      this.layer = layer;
    }

    // Extract the specific layers
    [this.windsAloftLayer, this.tempsAloftLayer] =
      this.layer?.layers.toArray() as TwcVectorTileLayer[];

    // Ensure we're watching metadata for both child layers
    this.setupChildLayersMetadataWatch();
  }

  /**
   * Set up additional metadata watches for the child layers
   */
  private setupChildLayersMetadataWatch(): void {
    if (!this.layer) return;

    // Watch for metadata changes on child layers
    [this.windsAloftLayer, this.tempsAloftLayer].forEach((childLayer) => {
      if (!childLayer?.metadata) return;

      const handle = this.setupWatch(
        () => childLayer.metadata?.['updatedAt'],
        (updatedAt: number) => this.handleMetadataUpdate(updatedAt)
      );

      if (handle) {
        this.watchHandles.add(handle);
      }
    });
  }
}
